import React, { useState, useEffect } from "react";
import AddPharmacyItem from "./AddPharmacyItems";
import { getPharmacyItems } from "../../apis/pharmacyItems";
import { getPharmacyItemById, updatePharmacyItem } from "../../apis/pharmacyItems";
import { Pagination, PaginationProps, Tag, Button, Dropdown, Tooltip } from "antd";
import { MedicineBoxOutlined, ExperimentOutlined } from "@ant-design/icons";
import { BeakerIcon, ArchiveBoxIcon } from "@heroicons/react/24/solid";
import CommonPagination from "../../components/CommanPagination";
const getStatusColor = (isActive: boolean) => {
  return isActive ? "green" : "red";
};

const PharmacyItemsList = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [pharmacyItems, setPharmacyItems] = useState<any[]>([]);
  const [editableItem, setEditableItem] = useState<any>(null);
  const [meta, setMeta] = useState<any>();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  // const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const openModal = () => {
  setEditableItem(null); 
  setIsModalOpen(true);
};

  // Fetch items
  const fetchItems = (params: any = { page: 1, per_page: 10 }) => {
    getPharmacyItems(params)
      .then((res: any) => {
        console.log("API Response:", res);
        setPharmacyItems(res.data || []);
        setMeta(res.meta);
      })
      .catch((err) => console.error(err));
  };

  useEffect(() => {
  fetchItems({ page, per_page: pageSize });
}, [page, pageSize]);

  const handleEditItem = (item: any) => {
  const itemId = item.id;
  getPharmacyItemById(itemId)
    .then((res: any) => {
      setEditableItem(res);  
      setIsModalOpen(true);
    })
    .catch((err) => console.error(err));
};


const handleToggleConsumable = (item: any) => {
  const updatedItem = { ...item, isConsumable: !item.isConsumable };
  // Only update isConsumable 
  updatePharmacyItem(item.id, { is_consumable: updatedItem.isConsumable })
    .then(() => {
      setPharmacyItems(prev =>
        prev.map(i => (i.id === item.id ? updatedItem : i))
      );
    })
    .catch(err => console.error(err));
};

const handleToggleActive = (item: any) => {
  const updatedItem = { ...item, isActive: !item.isActive };
  // Only update isActive 
  updatePharmacyItem(item.id, { is_active: updatedItem.isActive })
    .then(() => {
      setPharmacyItems(prev =>
        prev.map(i => (i.id === item.id ? updatedItem : i))
      );
    })
    .catch(err => console.error(err));
};

//   const onPaginationChange: PaginationProps["onChange"] = (page, pageSize) => {
//   setPage(page);
//   setPageSize(pageSize);
//   fetchItems({ page, per_page: pageSize });
// };
const onPaginationChange = (page: number, pageSize?: number) => {
  fetchItems({ page, per_page: pageSize || 10 }); 
};

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      {/* Header */}
      <div className="sm:flex sm:items-center sm:justify-between">
        <div>
          <h1 className="text-base font-semibold leading-6 text-gray-900">Pharmacy Items List</h1>
          <p className="mt-2 text-sm text-gray-700">List of all pharmacy items.</p>
        </div>

        <div className="flex gap-3">
          <button
            type="button"
            onClick={openModal}
            className="block px-3 py-2 text-sm font-semibold text-center text-white rounded-md shadow-sm bg-primary hover:bg-hover"
          >
            Add Pharmacy Item
          </button>
          <button
            type="button"
            className="px-3 py-2 text-sm font-semibold text-white rounded-md shadow-sm bg-primary hover:bg-hover"
          >
            Export
          </button>
        </div>
      </div>

      {/* Table */}
      <div className="flow-root mt-8">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
              <table className="min-w-full divide-y divide-gray-300">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">Item Name</th>
                    <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Form</th>
                    <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Strength</th>
                    <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Unit</th>
                    <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Status</th>
                    <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Action</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {pharmacyItems.map((item) => (
                    <tr key={item.id}>
                      <td className="py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6 flex gap-3">
                        <Tooltip title={item.isConsumable ? "Consumable" : "Non-Consumable"}>
                          {item.isConsumable ? (
                            <BeakerIcon
                              className="h-6 w-5 text-black cursor-pointer"
                              onClick={() => handleToggleConsumable(item)}
                            />
                          ) : (
                            <MedicineBoxOutlined
                              style={{ fontSize: "18px", color: "black", cursor: "pointer" }}
                              onClick={() => handleToggleConsumable(item)}
                            />
                          )}
                        </Tooltip>

                        {item.name}
                      </td>
                      <td>{item.form}</td>
                      <td>{item.strength}</td>
                      <td>{item.unit}</td>
                      <td className="px-3 py-4 text-sm whitespace-nowrap">
                        {/* <Tag color={getStatusColor(item.isActive)}>
                          {item.isActive ? "ACTIVE" : "INACTIVE"}
                        </Tag> */}
                        <Tag
                        color={getStatusColor(item.isActive)}
                        onClick={() => handleToggleActive(item)}
                        style={{ cursor: "pointer" }}
                      >
                        {item.isActive ? "ACTIVE" : "INACTIVE"}
                      </Tag>
                      </td>
                      <td className="py-4 px-3 text-sm text-gray-700">
                        <button
                          onClick={() => handleEditItem(item)}
                          className="block px-3 py-2 text-white bg-primary rounded hover:bg-hover"
                        >
                          Edit
                        </button>
                      </td>

                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {/* <div className="flex justify-end pt-5">
              <Pagination
                current={page}
                pageSize={pageSize}
                total={meta?.total || 0}
                onChange={onPaginationChange}
              />
            </div> */}
            <CommonPagination meta={meta} onChange={onPaginationChange} />
          </div>
        </div>
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-2xl max-h-[96vh] overflow-y-auto relative">

            {/* HEADER */}
            <div className="flex items-center justify-between bg-primary text-white px-4 py-3 rounded-t-lg">
              <h2 className="text-lg font-semibold">
                {editableItem ? "Update Pharmacy Item" : "Add Pharmacy Item"}
              </h2>

              <button
                onClick={closeModal}
                className="text-white hover:text-gray-200 text-xl font-bold"
              >
                ✕
              </button>
            </div>

            {/* BODY */}
            <div className="p-6">
              <AddPharmacyItem
                closeModal={() => {
                  setIsModalOpen(false); // Close modal
                  fetchItems();         // Refresh list
                  setEditableItem(null);
                }}
                editableItem={editableItem}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PharmacyItemsList;
